import { render, staticRenderFns } from "./IdCardRegister.vue?vue&type=template&id=38c33a06&scoped=true"
import script from "./IdCardRegister.vue?vue&type=script&lang=js"
export * from "./IdCardRegister.vue?vue&type=script&lang=js"
import style0 from "./IdCardRegister.vue?vue&type=style&index=0&id=38c33a06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c33a06",
  null
  
)

export default component.exports